module.exports = __webpack_public_path__ + "static/sample-16-6da7e88583da3ed1e833e29487152567.png";